import React, { useEffect, useState, useCallback } from 'react';
import SkeletonLoader from './components/AgendaContent/SkeletonLoader';
import Filter from './Filter';

import { today, dbDateToTimestamp } from './utils/helpers';


const App = ({ config, rootElement }) => {

	//state reflecting data and filtered data
	const [filterFeed, setFilterFeed] = useState(null); //source data
	const [fetching, setFetching] = useState(true);

	//params available in dropdown for filter
	// const [availableLocations, setAvailableLocations] = useState([]);
	const [availableDates, setAvailableDates] = useState([]);
	const [availableTags, setAvailableTags] = useState([]); //genres
	const [availableCategories, setAvailableCategories] = useState([]); //"ontdekken"/discover

	/**
	 * @description	Fetching feed
	 */
	async function fetchData() {
		const response = await fetch('/filter_feed_json');
		if (!response.ok) {
			const message = `An error has occured: ${response.status}`;
    		throw new Error(message);
		}
		const data = await response.json();
		return data;
	};

  	/**
	 * @description	Retrieves available parameters for filtering from the feed + sets the state
	 * 					And adds a js date to the feed data
	 */
	const parseFilterData = useCallback((data) => {
		const dataCopy = structuredClone(data);
		const allTags = [];
		const allCategories = [];
		const parsedData = [];

		Object.values(dataCopy).forEach((filter) => {


			if (filter?.type && Object.keys(filter.type).length > 0) {
            Object.keys(filter.type).forEach((slug) => {
                !allTags.some(tag => Object.keys(tag)[0] === slug) && allTags.push({ [slug]: filter.type[slug] });
            });
        }
				if (filter?.sector && Object.keys(filter.sector).length > 0) {
					Object.keys(filter.sector).forEach((slug) => {
					!allCategories.some(category => Object.keys(category)[0] === slug) && allCategories.push({ [slug]: filter.sector[slug] });
					});
			}
			parsedData.push(filter);
		});

		setAvailableTags(allTags);
		setAvailableCategories(allCategories);

		return parsedData;
	}, [config]);

	useEffect(() => {
		fetchData().then((data) => {
			setFilterFeed(parseFilterData(data.filters));
			setFetching(false);
		});

		 // Hide the placeholder when React is loaded
		 const placeholders = document.getElementsByClassName('js-react-placeholder');
		 Array.from(placeholders).forEach(placeholder => {
			  placeholder.style.display = 'none';
		 });
	}, []);

	if (fetching) return (
		<SkeletonLoader />
  );

	return (
		<Filter
			config={config}
			filterFeed={filterFeed}
			// promoData={promoData}
			// availableLocations={availableLocations}
			// availableDates={availableDates}
			availableTags={availableTags}
			availableCategories={availableCategories}
			rootElement={rootElement}
		/>
	);
};

export default App;
